/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";
import parse from "html-react-parser";
class VoiceItem extends Component {
  state = {
    view: false,
  };
  _onToggleView = () => {
    const { view } = this.state;

    this.setState({
      view: !view,
    });
  };
  _stepClick = () => {
    const { history, setContentSerial } = this.props;
    const { contentSerial, stepClose } = this.props.childProps;
    //stepClick(cv_Idx)
    stepClose();
    //setContentSerial(0)

    if (this.props.contentSerial > 0) {
      //console.log('삭제 후 이동')
      setContentSerial(0);

      setTimeout(() => {
        history.push("/items/" + contentSerial);
      }, 300);
    } else {
      //console.log('이동')
      history.push("/items/" + contentSerial);
    }
    /*
        setTimeout(()=>{
            setContentSerial(0)
            //const { setContentSerial } = this.props;
            //setContentSerial(contentSerial)
            //history.push('/items/' + contentSerial)
        }, 1100)

        setTimeout(()=>{
            //setContentSerial(0)
            //const { setContentSerial } = this.props;
            setContentSerial(contentSerial)
            //history.push('/items/' + contentSerial)
        }, 1500)
        */
  };
  render() {
    // const { view } = this.state;
    const { title, stepName, stepImage, comment } = this.props.childProps;

    let name = stepName.substr(0, stepName.indexOf("("));
    return (
      <Fragment>
        <div className="div_li">
          <div className="inmul_img">
            {/*<span><img src="/img/detail_img/min_top10.png"/></span>*/}
            <div>
              <img src={stepImage} />
            </div>
          </div>
          <h2>
            {name}

            <span>
              {/*<img src="/img/detail_img/etc_icon.png" style={{ cursor: 'pointer'}} onClick = {this._onToggleView}/>*/}
            </span>
          </h2>
          <em
            style={{ cursor: "pointer", color: "#ff5d24" }}
            onClick={this._stepClick}
          >
            {title}
          </em>
          <p>{parse(comment)}</p>{" "}
          {/*parse(item.title.replace(/<[^>]+>/g, '')) */}
          <div className="right_img">{/*<img src="/img/heart_max.png"/>*/}</div>
        </div>
        {/*
                <div className="div_li">
                    <div className="inmul_img"><div><img src="/img/detail_img/test_img.png"/></div></div>
                    <h2>페코린느</h2>
                    <em>성우: 미나세 이노리</em>
                    <p>에밀리아 앞에 나타난 회색<br/>에밀리아 앞에 나타난 회</p>
                    <div className="right_img">
                        <img src="/img/heart_max.png"/>
                        <strong>2,304</strong>
                    </div>
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(VoiceItem));
